import { useMutation, useQuery } from "@tanstack/react-query";
import { customFetcher } from "../useFetch";
import { IAutomation } from "../../interfaces/IAutomation";
import { IAutomationCategory } from "../../interfaces/IAutomationCategory";
import { IAutomationTrigger } from "../../interfaces/IAutomationTrigger";
import { IAutomationResponse } from "../../interfaces/IAutomationResponse";
import { IAutomationMailWorkerEdit } from "../../interfaces/IAutomationMail";

export const useUpdateAutomation = () => {
    const { mutateAsync: updateAutomation, isPending: isPendingUpdateAutomation } = useMutation({
        mutationFn: (currentObject: IAutomation) =>
            customFetcher({
                endpoint: `/automation/${currentObject.id}`,
                method: "PUT",
                body: currentObject,
            }),
    });

    return {
        updateAutomation,
        isPendingUpdateAutomation,
    };
};

export const useCreateAutomation = () => {
    const { mutateAsync: createAutomation, isPending: isPendingCreateAutomation } = useMutation({
        mutationFn: (currentObject: IAutomation) =>
            customFetcher({
                endpoint: `/automation/`,
                method: "POST",
                body: currentObject,
            }),
    });

    return {
        createAutomation,
        isPendingCreateAutomation,
    };
};

export const useCreateAutomationTrigger = () => {
    const { mutateAsync: triggerAutomation, isPending: isPendingTriggerAutomation } = useMutation<
        IAutomationResponse,
        Error,
        IAutomationTrigger
    >({
        mutationFn: (currentObject: IAutomationTrigger) =>
            customFetcher({
                endpoint: `/automation/trigger/`,
                method: "POST",
                body: currentObject,
            }),
    });

    return {
        triggerAutomation,
        isPendingTriggerAutomation,
    };
};

export const useSendAutomationEmails = () => {
    const { mutateAsync: sendAutomationEmails, isPending: isPendingSendAutomationEmails } = useMutation({
        mutationFn: (currentObject: IAutomationMailWorkerEdit[]) =>
            customFetcher({
                endpoint: `/automation/send_mails/`,
                method: "POST",
                body: currentObject,
            }),
    });

    return {
        sendAutomationEmails,
        isPendingSendAutomationEmails,
    };
};

export const useDeleteAutomation = () => {
    const { mutateAsync: deleteAutomation, isPending: isPendingDeleteAutomation } = useMutation({
        mutationFn: (idDelte: number) =>
            customFetcher({
                endpoint: `/automation/${idDelte}`,
                method: "DELETE",
            }),
    });

    return {
        deleteAutomation,
        isPendingDeleteAutomation,
    };
};

export const useGetAutomation = () => {
    const {
        data: automationArary,
        isLoading: isLoadingAutomationArray,
        refetch: refetchAutomationArray,
    } = useQuery<IAutomation[]>({
        queryKey: ["automation/"],
        queryFn: () => customFetcher({ endpoint: "/automation/" }),
    });
    return { automationArary, isLoadingAutomationArray, refetchAutomationArray };
};

export const useGetAutomationCategory = () => {
    const {
        data: automationCategoryArary,
        isLoading: isLoadingAutomationCategoryArray,
        refetch: refetchAutomationCategoryArray,
    } = useQuery<IAutomationCategory[]>({
        queryKey: ["automation/category/"],
        queryFn: () => customFetcher({ endpoint: "/automation/category/" }),
    });
    return { automationCategoryArary, isLoadingAutomationCategoryArray, refetchAutomationCategoryArray };
};
